"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentOrigin = exports.ExperienceTypes = exports.Variants = exports.AppointmentTypes = exports.GenderRequestedOptions = exports.AppointmentBookingStatus = exports.AppointmentSchedulingStatus = void 0;
var AppointmentSchedulingStatus;
(function (AppointmentSchedulingStatus) {
    AppointmentSchedulingStatus["SCHEDULED"] = "Scheduled";
    AppointmentSchedulingStatus["CANCELLED"] = "Cancelled";
})(AppointmentSchedulingStatus = exports.AppointmentSchedulingStatus || (exports.AppointmentSchedulingStatus = {}));
var AppointmentBookingStatus;
(function (AppointmentBookingStatus) {
    AppointmentBookingStatus["NONE"] = "None";
    AppointmentBookingStatus["REQUESTED"] = "Requested";
    AppointmentBookingStatus["BOOKED"] = "Booked";
    AppointmentBookingStatus["COMPLETED"] = "Completed";
    AppointmentBookingStatus["CONFIRMED"] = "Confirmed";
    AppointmentBookingStatus["ARRIVED"] = "Arrived";
    AppointmentBookingStatus["NOSHOW"] = "NoShow";
    AppointmentBookingStatus["CANCELLED"] = "Cancelled";
    AppointmentBookingStatus["LATECANCELLED"] = "LateCancelled";
})(AppointmentBookingStatus = exports.AppointmentBookingStatus || (exports.AppointmentBookingStatus = {}));
var GenderRequestedOptions;
(function (GenderRequestedOptions) {
    GenderRequestedOptions["MALE"] = "Male";
    GenderRequestedOptions["FEMALE"] = "Female";
    GenderRequestedOptions["NONE"] = "None";
})(GenderRequestedOptions = exports.GenderRequestedOptions || (exports.GenderRequestedOptions = {}));
var AppointmentTypes;
(function (AppointmentTypes) {
    AppointmentTypes["INTRO"] = "IntroLesson";
    AppointmentTypes["GROUP"] = "GroupLesson";
    AppointmentTypes["PRIVATE"] = "PrivateLesson";
    AppointmentTypes["RENTAL"] = "SimRental";
    AppointmentTypes["PARTY_RENTAL"] = "PartySimRental";
    AppointmentTypes["CUSTOM"] = "CustomLesson";
    AppointmentTypes["CLASS"] = "Class";
    AppointmentTypes["BOWLING"] = "BowlingRental";
    AppointmentTypes["PARTY_BOWLING"] = "PartyBowlingRental";
    AppointmentTypes["CLUB_FITTING"] = "ClubFitting";
})(AppointmentTypes = exports.AppointmentTypes || (exports.AppointmentTypes = {}));
var Variants;
(function (Variants) {
    Variants["DUCKPIN"] = "duckpin";
    Variants["FIVEIRON"] = "fiveIron";
})(Variants = exports.Variants || (exports.Variants = {}));
var ExperienceTypes;
(function (ExperienceTypes) {
    ExperienceTypes["BOWLING"] = "Bowling";
    ExperienceTypes["GOLF"] = "Golf";
})(ExperienceTypes = exports.ExperienceTypes || (exports.ExperienceTypes = {}));
var AppointmentOrigin;
(function (AppointmentOrigin) {
    AppointmentOrigin["MOBILE"] = "Mobile";
    AppointmentOrigin["WEB"] = "Web";
    AppointmentOrigin["WEBHOOK"] = "Webhook";
    AppointmentOrigin["SYNC"] = "Sync";
})(AppointmentOrigin = exports.AppointmentOrigin || (exports.AppointmentOrigin = {}));
//# sourceMappingURL=MboAppointmentTypes.js.map